import React, { FC, useCallback, MouseEvent } from 'react'

import {
  IVoidCallback,
} from '../../types/utils'

interface JobViewLinkProps {
  className?: string,
  onClick: IVoidCallback,
}

const ClickLink: FC<JobViewLinkProps> = ({
  className,
  onClick,
  children,
}) => {

  const onOpen = useCallback((e: MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    onClick()
    return false
  }, [
    onClick,
  ])

  return (
    <a href="#" onClick={ onOpen } className={ className }>
      { children }
    </a>
  )
}

export default ClickLink